__turbopack_context__.v({
  "root": "PlasmicSliderThumb-module__Iu9O1W__root",
});
